import { createSlice } from "@reduxjs/toolkit";
import { updateCommunityApi } from "../CommunityAPI/communityApi";

const communityUpdateSlice = createSlice({
  name: "communityUpdate",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(updateCommunityApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCommunityApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateCommunityApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default communityUpdateSlice.reducer;
